import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullScreen?: boolean;
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  fullScreen = false,
  message = 'Loading...',
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  const spinner = (
    <div
      className={`animate-spin rounded-full border-b-2 border-red-500 ${sizeClasses[size]} ${className}`}
    >
      <span className="sr-only">{message}</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
        <div className="flex flex-col items-center space-y-4">
          <div
            className={`animate-spin rounded-full border-b-2 border-red-500 ${sizeClasses[size]}`}
          >
            <span className="sr-only">{message}</span>
          </div>
          {message && <p className="text-sm text-gray-600 font-medium">{message}</p>}
        </div>
      </div>
    );
  }

  // For page-level loading (default for most cases)
  if (!className.includes('inline') && !className.includes('relative')) {
    return (
      <div className="flex items-center justify-center min-h-[400px] w-full">
        <div className="flex flex-col items-center space-y-4">
          {spinner}
          {message && message !== 'Loading...' && (
            <p className="text-sm text-gray-600 font-medium">{message}</p>
          )}
        </div>
      </div>
    );
  }

  // For inline usage (buttons, etc.)
  return spinner;
};

export default LoadingSpinner;
